import type { Category, Service } from '#ourahub-intra/types/services'

export const SERVICE_PUBLISH_REVIEWERS = [
  'janne.julkunen@ouraring.com',
  'otto.soderman@ouraring.com',
  'juho.syrjanen@ouraring.com',
]

export const GITHUB_PROTOTYPE_ORG = 'oura-health-playground'

export const PUBLISH_STAGES = ['sandbox', 'staging', 'release'] as const

export const PUBLISH_REQUESTABLE_STAGES = ['sandbox', 'staging'] as const

export const ADDABLE_STAGES = ['staging'] as const

export const STAGE_VERSION_NAMES = { sandbox: 'Development', staging: 'Experimental', release: 'Production' } as const

export const stageIndex = (stage?: string) => (PUBLISH_STAGES as readonly string[]).indexOf(stage ?? '')

// Stages up to the accepted one can be published without a new review.
export const isAcceptedStage = (service: Service, stage: string) => {
  return Boolean(service.acceptedFor) && stageIndex(stage) <= stageIndex(service.acceptedFor)
}

export const SHARED_HOSTING_DOMAINS = {
  sandbox: 'shared.ourahub-sandbox.com',
  staging: 'shared.ourahub-staging.com',
  release: 'shared.ourahub.com',
} as const

export const buildServiceUrl = (serviceId: string, env: keyof typeof SHARED_HOSTING_DOMAINS) =>
  `https://${serviceId}.${SHARED_HOSTING_DOMAINS[env]}`

export const contextTypes = [
  {
    title: 'Standalone internal API service (Any Client)',
    value: 'api-service',
  },
  {
    title: 'Standalone internal MCP service (AI Clients)',
    value: 'mcp-service',
  },
  /*{
      title: 'Standalone internal cron job task (Scheduled)',
      value: 'cron-job-task',
    },*/
  {
    title: 'Web app with optional API backend (OuraHub)',
    value: 'web-service-spa',
  },
  {
    title: 'Web app with server-side rendering (Standalone)',
    value: 'web-service-ssr',
  },
]

export const requiredRule = (value: unknown) => !!value || 'This field is required'

export const existingIdRule = (services: Service[], value: string) =>
  !services.find((s) => s.id === value) || 'There is already an application with this ID!'

export const existingNameRule = (services: Service[], value: string) =>
  !services.find((s) => s.name === value) || 'There is already an application with this name!'

export const existingIconRule = (services: Service[], value: string) =>
  !services.find((s) => s.icon === value) || 'There is already an application with this icon!'

export const existingIconsRule = (categories: Category[], value: string) =>
  !categories.find((c) => c.icon === value) || 'There is already a category with this icon!'

export const applicationIdRule = (value: string) =>
  value.startsWith('outo-') || value.includes('ourahub')
    ? 'Application ID cannot contain "outo" or "ourahub"!'
    : (/^[a-z][a-z0-9]+(-[a-z0-9]+){1,4}$/.test(value) && value.length >= 10 && value.length <= 30) ||
      'Use lowercase letters and hyphens (10-30 characters)'

export const applicationNameRule = (value: string) =>
  ((value?.trim().length ?? 0) >= 10 && (value?.trim().length ?? 0) <= 30) ||
  'Application name must be between 10 and 30 characters long!'

export const applicationSummaryRule = (value: string) =>
  ((value?.trim().length ?? 0) >= 50 && (value?.trim().length ?? 0) <= 100) ||
  'Summary text must be between 50 and 100 characters long!'
